import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { css } from 'styled-components';
import SVGAttach from 'visitor-ui-component-library-icons/icons/SVGAttach';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TruncateStringStyled = styled.div.withConfig({
  displayName: "ThreadPreviewText__TruncateStringStyled",
  componentId: "pwt96p-0"
})(["line-height:1.5rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:12px;margin-bottom:0 !important;", ""], ({
  unseenCount
}) => unseenCount && css(["font-weight:600;margin-bottom:16px;margin-top:0;"]));
function ThreadPreviewText({
  unseenCount,
  text,
  hasAttachment,
  hasChatEnded,
  className,
  hasChatBeenTransferred
}) {
  if (hasChatEnded) {
    return /*#__PURE__*/_jsx(TruncateStringStyled, {
      unseenCount: unseenCount,
      className: className,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.threadList.chatEndedMessage"
      })
    });
  }
  if (hasChatBeenTransferred) {
    return /*#__PURE__*/_jsx(TruncateStringStyled, {
      unseenCount: unseenCount,
      className: className,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.newThreadPrompt.chatMovedToEmail"
      })
    });
  }
  if (!hasAttachment) {
    return /*#__PURE__*/_jsx(TruncateStringStyled, {
      unseenCount: unseenCount,
      className: className,
      children: text
    });
  }
  return /*#__PURE__*/_jsxs(TruncateStringStyled, {
    unseenCount: unseenCount,
    className: className,
    children: [/*#__PURE__*/_jsx(VizExIcon, {
      className: "m-right-2",
      icon: /*#__PURE__*/_jsx(SVGAttach, {})
    }), text || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cvVisitorUIAttachments.threadPreview"
    })]
  });
}
ThreadPreviewText.displayName = 'ThreadPreviewText';
ThreadPreviewText.propTypes = {
  className: PropTypes.string,
  hasAttachment: PropTypes.bool.isRequired,
  hasChatEnded: PropTypes.bool.isRequired,
  text: PropTypes.string,
  unseenCount: PropTypes.number.isRequired
};
export default ThreadPreviewText;